import { combineReducers } from "redux";

import auth from "./auth.js";
import oldtickets from "./oldtickets.js";
import ticket from './ticket.js';
import cliente from './cliente.js';
import departamento from './departamentos.js';
import user from './user.js';
import inventario from './inventario.js';
import categorias from './categorias.js';
import descuentos from './descuentos.js';
import participaciones from './participaciones.js';
import proveedores from './proveedores.js';
import impuestos from './impuestos.js';
import lineas from './lineas.js';
import marcas from './marcas.js';
import estilos from './estilos.js';
import coloressabores from './coloressabores.js';
import medidas from './medidas.js';
import embarques from './embarques.js';
import lab from './lab.js';
import descuentosf from './descuentosf.js';
import tiposmovimientos from './tiposmovimientos.js';
import tiposconceptos from './tiposconceptos.js';
import almacenes from './almacenes.js';
import terminospagos from './terminospagos.js';
import folios from './folios.js';
import plazosvencimientos from './plazosvencimientos.js';
import tiposcambio from './tiposcambio.js';
import parametros from './parametros.js';
import datosfacturacion from './datosfacturacion.js';
import movimientocompra from './movimientocompra.js';
import inventarioFisico from './inventarioFisico.js';
import movimientocaproveedores from './movimientocaproveedores.js';
import movimientoalmacen from './movimientoalmacen.js';
import movimientocaclientes from './movimientocaclientes.js';
import factura from './factura.js';
import notificaciones from './notificaciones.js';
import eventos from './eventos.js';
import balancegeneral from './balancegeneral.js';


const reducers = combineReducers({
	auth,
	oldtickets,
	ticket,
	cliente,
	departamento,
	user,
	inventario,
	categorias,
	descuentos,
	participaciones,
	proveedores,
	impuestos,
	lineas,
	marcas,
	estilos,
	coloressabores,
	medidas,
	embarques,
	lab,
	descuentosf,
	tiposmovimientos,
	tiposconceptos,
	almacenes,
	terminospagos,
	folios,
	plazosvencimientos,
	tiposcambio,
	parametros,
	datosfacturacion,
	movimientocompra,
	inventarioFisico,
	movimientocaproveedores,
	movimientoalmacen,
	movimientocaclientes,
	factura,
	notificaciones,
	eventos,
	balancegeneral,

});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js